import React from 'react';

import './LoadingSpinner.css';

function LoadingSpinner() {
  return (
    <div className="loadingio-spinner-spin-o3b9lsypv7e">
      <div className="ldio-3itc8bbbeep">
        <div>
          <div />
        </div>
        <div>
          <div />
        </div>
        <div>
          <div />
        </div>
        <div>
          <div />
        </div>
        <div>
          <div />
        </div>
        <div>
          <div />
        </div>
        <div>
          <div />
        </div>
        <div>
          <div />
        </div>
      </div>
    </div>
  );
}

export default LoadingSpinner;
